/**
 * @generated SignedSource<<bc1bd463526bd950e750fe8ecb3f06a6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SkillCategoryRow_skills$data = ReadonlyArray<{
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"SkillRow_skill">;
  readonly " $fragmentType": "SkillCategoryRow_skills";
}>;
export type SkillCategoryRow_skills$key = ReadonlyArray<{
  readonly " $data"?: SkillCategoryRow_skills$data;
  readonly " $fragmentSpreads": FragmentRefs<"SkillCategoryRow_skills">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "SkillCategoryRow_skills",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SkillRow_skill"
    }
  ],
  "type": "Skill",
  "abstractKey": null
};

(node as any).hash = "db345436be00c622fa3776298ced3ab4";

export default node;
